import Cookies from "js-cookie";
import ClipboardJS from "clipboard";

const isYourListPage = window.location.pathname === "/your-list/";
const isDev = window.location.hostname.includes("localhost");

// Add/Remove Buttons in cards
const updateListBtns = document.querySelectorAll("button[data-service-id]");

if (updateListBtns) {
  initUserList();

  updateListBtns.forEach((btn) => {
    const serviceId = btn.getAttribute("data-service-id");

    if (!serviceId) return;

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      updateUserList(serviceId, btn as HTMLElement);
    });
  });
}

function initUserList() {
  const userList = Cookies.get("userList");
  if (!userList) {
    Cookies.set("userList", "");
  } else {
    initUserListBtns();
  }
}

function initUserListBtns() {
  const userList = Cookies.get("userList");
  const userListParsed = userList ? JSON.parse(userList) : [];
  const serviceIds = userListParsed.map((item: any) => item);

  updateListBtns.forEach((btn) => {
    const serviceId = btn.getAttribute("data-service-id");

    if (!serviceId) return;

    if (serviceIds.includes(serviceId)) {
      btn.textContent = "Remove from List";
      btn.classList.add("button--added");
    }
  });
  updateButtons();
}

function updateUserList(serviceId: string, btn: HTMLElement) {
  const userList = Cookies.get("userList");
  const userListParsed = userList ? JSON.parse(userList) : [];
  const isServiceExist = userListParsed.some((item: any) => item === serviceId);

  if (isServiceExist) {
    const updatedList = userListParsed.filter((item: any) => item !== serviceId);
    Cookies.set("userList", JSON.stringify(updatedList));
    btn.textContent = "Add to List";
    btn.classList.remove("button--added");

    if (isYourListPage) {
      updateDoms(serviceId);
    }
  } else {
    userListParsed.push(serviceId);
    Cookies.set("userList", JSON.stringify(userListParsed));
    btn.textContent = "Remove from List";
    btn.classList.add("button--added");
  }

  if (!isDev) {
    gtag("event", isServiceExist ? "remove_from_list" : "add_to_list", {});
  }
  updateButtons();
}

function updateDoms(serviceId: string) {
  const serviceCard = document.querySelector(`.resultCard[data-id="${serviceId}"]`);
  if (serviceCard) {
    serviceCard.classList.add("removed");
  }
}

function updateButtons() {
  const userList = Cookies.get("userList");
  const userListParsed = userList ? JSON.parse(userList) : [];

  const copyListBtn = document.querySelector("#copyList");
  if (copyListBtn) {
    copyListBtn.setAttribute(
      "data-clipboard-text",
      `${window.location.href}?ids=${userListParsed.join(",")}`
    );
  }

  const emailListBtn = document.querySelector("#emailList");
  if (emailListBtn) {
    emailListBtn.setAttribute(
      "href",
      `mailto:?subject=Your%20resources%20list%20-%20211%20British%20Columbia&body=View%20your%20list:%20${
        window.location.href
      }?ids=${userListParsed.join(",")}`
    );
  }

  const yourListButton = document.querySelector(".header-tools-list");
  if (yourListButton) {
    if (userListParsed.length === 0) {
      yourListButton.innerHTML = "<span>Your</span> List";
    } else {
      yourListButton.innerHTML = `<span>Your</span> List <span>(${userListParsed.length})</span>`;
    }
  }
}

// When the page is Your List, reload the page when the tab is visible
if (isYourListPage) {
  window.addEventListener("visibilitychange", () => {
    const userList = Cookies.get("userList");
    if (userList) {
      window.location.reload();
    }
  });
}

// Buttons in the page
const clearListBtn = document.querySelector("#clearList");
const copyListBtn = document.querySelector("#copyList");
// Note: Print and Share button is in action-buttons.ts

// Clear List
if (clearListBtn) {
  clearListBtn.addEventListener("click", (e) => {
    e.preventDefault();
    Cookies.set("userList", "");
    window.location.reload();
  });
}

if (copyListBtn) {
  const clipboard = new ClipboardJS(copyListBtn);
  clipboard.on("success", (e: any) => {
    e.clearSelection();
    copyListBtn.textContent = "Link Copied!";
    setTimeout(() => {
      copyListBtn.textContent = "Copy Link to List";
    }, 2000);
  });
}
